import {ArrayUtils, IPlayOptions, PlayMode} from "html-living-framework";
import {ItemModel, ItemType} from "./ItemModel";
import {VoiceOverManager} from "../Managers/VoiceOverManager";
import {Callback} from "../Core/Reflection";
import {PuzzleModel, PuzzleType} from "../GameObjects/Puzzle/PuzzleModel";

export const voOptionsButtons = {priority: 0};
export const voOptionsIdle = {priority: 0, mode: PlayMode.New};
export const voOptionsRepeat = {priority: 5};
export const voOptionsDirections = {priority: 10};
export const voOptionsOnboarding = voOptionsDirections;
export const voOptionsFacts = {priority: 20};

const fromVO = {
    [ItemType.Robot]: "LetsGoLuna_039",
    [ItemType.Monster]: "LetsGoLuna_040",
    [ItemType.Pasta]: "LetsGoLuna_037",
    [ItemType.Movie]: "LetsGoLuna_041",
    [ItemType.Delight]: "LetsGoLuna_036",
    [ItemType.Durian]: "LetsGoLuna_035",
    [ItemType.Coconut]: "LetsGoLuna_038",
    [ItemType.Glockenspiel]: "LetsGoLuna_042",
    [ItemType.Bagpipes]: "LetsGoLuna_043",
    [ItemType.Nyatiti]: "LetsGoLuna_045",
    [ItemType.Didgeridoo]: "LetsGoLuna_044",
    [ItemType.Puzzle + PuzzleType.Type1]: "LetsGoLuna_046",
    [ItemType.Puzzle + PuzzleType.Type2]: "LetsGoLuna_047_alt",
    [ItemType.Puzzle + PuzzleType.Type3]: "LetsGoLuna_048",
    [ItemType.Puzzle + PuzzleType.Type4]: "LetsGoLuna_049",
    [ItemType.Puzzle + PuzzleType.Type5]: "LetsGoLuna_050",
    [ItemType.Puzzle + PuzzleType.Type6]: "LetsGoLuna_051",
    [ItemType.Puzzle + PuzzleType.Type7]: "LetsGoLuna_052",
    [ItemType.Puzzle + PuzzleType.Type8]: "LetsGoLuna_053",
};
export function FromVO(model: ItemModel) {
    const type = model.itemType;
    return type === ItemType.Puzzle ?
        fromVO[type + (model.itemData as PuzzleModel).puzzleType] :
        fromVO[type];
}

const postcardVO = {
    [ItemType.Robot]: ["LetsGoLuna_068", 0.5, "LetsGoLuna_069"],
    [ItemType.Monster]: ["LetsGoLuna_080", 0.5, "LetsGoLuna_081"],
    [ItemType.Pasta]: ["LetsGoLuna_123", 0.5, "LetsGoLuna_124"],
    [ItemType.Movie]: ["LetsGoLuna_090", 0.5, "LetsGoLuna_091"],
    [ItemType.Delight]: ["LetsGoLuna_160", 0.5, "LetsGoLuna_161"],
    [ItemType.Durian]: ["LetsGoLuna_105", 0.5, "LetsGoLuna_106"],
    [ItemType.Coconut]: ["LetsGoLuna_180", 0.5, "LetsGoLuna_181"],
    [ItemType.Glockenspiel]: ["LetsGoLuna_194", 0.5, "LetsGoLuna_195"],
    [ItemType.Bagpipes]: ["LetsGoLuna_200", 0.5, "LetsGoLuna_201"],
    [ItemType.Nyatiti]: ["LetsGoLuna_205", 0.5, "LetsGoLuna_206"],
    [ItemType.Didgeridoo]: ["LetsGoLuna_209", 0.5, "LetsGoLuna_210"],
};
export function PostcardVO(model: ItemModel) {
    const type = model.itemType;
    return type === ItemType.Puzzle ?
        ["LetsGoLuna_238"] :
        postcardVO[type];
}

const reactionVO = [
    "LetsGoLuna_023",
    "LetsGoLuna_024",
    "LetsGoLuna_025",
    "LetsGoLuna_026",
    "LetsGoLuna_027",
    "LetsGoLuna_028",
    "LetsGoLuna_029",
    "LetsGoLuna_030"
];
ArrayUtils.shuffle(reactionVO);
let reactionVOIndex = -1;
export function ReactionVO() {
    reactionVOIndex++;
    if (reactionVOIndex % 3 !== 0) {
        return [];
    }
    const vo = reactionVO.shift()!;
    reactionVO.push(vo);
    return [vo];
}

export const KitHoverVO = {
    [ItemType.Robot]: "LetsGoLuna_060",
    [ItemType.Monster]: "LetsGoLuna_061",
    [ItemType.Pasta]: "LetsGoLuna_058",
    [ItemType.Movie]: "LetsGoLuna_062",
    [ItemType.Delight]: "LetsGoLuna_057",
    [ItemType.Durian]: "LetsGoLuna_056",
    [ItemType.Coconut]: "LetsGoLuna_059",
    [ItemType.Glockenspiel]: "LetsGoLuna_063",
    [ItemType.Bagpipes]: "LetsGoLuna_064",
    [ItemType.Nyatiti]: "LetsGoLuna_066",
    [ItemType.Didgeridoo]: "LetsGoLuna_065",
    [ItemType.Puzzle]: "LetsGoLuna_067",
};

export function nextRandomVO(vos: string[]) {
    const vo = vos.pop()!;
    ArrayUtils.shuffle(vos);
    vos.unshift(vo);
    return vo;
}

export function nextVO(vos: string[]) {
    const vo = vos.shift()!;
    vos.push(vo);
    return vo;
}

export function playVO(vo: string | (string | number)[], options?: IPlayOptions | Callback) {
    if (!options) {
        options = voOptionsDirections;
    } else if (typeof options === "function") {
        options = {...voOptionsDirections, callback: options};
    } else {
        options = {...voOptionsDirections, ...options};
    }
    VoiceOverManager.instance.playVO(vo, options);
}

export function stopVO() {
    VoiceOverManager.instance.stopVO();
}